import React, { useRef, useEffect, useState } from "react";
  import { Helmet } from "react-helmet-async";
  import Popup from "../components/popup.js";
  import recright from "../assets/Home/recright.webp";
import governmentImg from "../assets/Managed/man1.webp";
import lawEnforcementImg from "../assets/Managed/man2.webp";
import sportsImg from "../assets/Managed/man3.webp";
import politicalImg from "../assets/Managed/man4.webp";
import bubble1 from "../assets/Managed/bubble1.webp";
import line from "../assets/Managed/line.webp";
import triangle from "../assets/Managed/triangle.webp";
  
  
  
  const IndustrySolutions = () => {
      const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(() => {
      // Set page title
      document.title = "Random Walk | Industry Solutions - AI for Every Sector";
  
      // Set meta description
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          "Tailored AI solutions designed for specific industries and their unique challenges. From government operations to sports management, our platforms adapt to your sector's needs."
        );
      } else {
        const meta = document.createElement("meta");
        meta.name = "description";
        meta.content =
          "Tailored AI solutions designed for specific industries and their unique challenges. From government operations to sports management, our platforms adapt to your sector's needs.";
        document.head.appendChild(meta);
      }
  
      // Add or update Open Graph title
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement("meta");
        ogTitle.setAttribute("property", "og:title");
        document.head.appendChild(ogTitle);
      }
      ogTitle.setAttribute(
        "content",
        "Random Walk | Industry Solutions - AI for Every Sector"
      );
  
      // Add or update Open Graph description
      let ogDescription = document.querySelector(
        'meta[property="og:description"]'
      );
      if (!ogDescription) {
        ogDescription = document.createElement("meta");
        ogDescription.setAttribute("property", "og:description");
        document.head.appendChild(ogDescription);
      }
      ogDescription.setAttribute(
        "content",
        "Tailored AI solutions designed for specific industries and their unique challenges. From government operations to sports management, our platforms adapt to your sector's needs."
      );
  
      // Add viewport meta tag
      let viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) {
        viewport = document.createElement("meta");
        viewport.name = "viewport";
        document.head.appendChild(viewport);
      }
      viewport.setAttribute("content", "width=device-width, initial-scale=1");
  
      // Add theme-color meta tag
      let themeColor = document.querySelector('meta[name="theme-color"]');
      if (!themeColor) {
        themeColor = document.createElement("meta");
        themeColor.name = "theme-color";
        document.head.appendChild(themeColor);
      }
      themeColor.setAttribute("content", "#000000");
  
      // Add Open Graph image
      let ogImage = document.querySelector('meta[property="og:image"]');
      if (!ogImage) {
        ogImage = document.createElement("meta");
        ogImage.setAttribute("property", "og:image");
        document.head.appendChild(ogImage);
      }
      ogImage.setAttribute("content", `${process.env.PUBLIC_URL}/rw_logo.png`);
  
      // Add Open Graph type
      let ogType = document.querySelector('meta[property="og:type"]');
      if (!ogType) {
        ogType = document.createElement("meta");
        ogType.setAttribute("property", "og:type");
        document.head.appendChild(ogType);
      }
      ogType.setAttribute("content", "website");
  
      // Add canonical link
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement("link");
        canonicalLink.rel = "canonical";
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.href = "https://randomwalk.ai/industry-solutions/";
    }, []);
  
const solutions = [
      {
        title: "Manufacturing",
        description:
          "AI is redefining how factories think, move, and deliver. With intelligent automation, predictive modeling, and precision-driven analytics, We help manufacturers evolve from reactive to self-optimizing systems.",
        image: governmentImg,
        departments: [
          "Production",
          "Quality",
          "Supply Chain",
          "Maintenance",
        ],
        highlights: [
          "Real-time anomaly detection with Visual AI for defect identification",
          "Predictive analytics to minimize downtime and optimize throughput",
          "Functional AI for intelligent process automation and scheduling",
          "Analytical AI for yield forecasting and performance benchmarking",
          "Integration-ready with PLC, IoT, and MES systems for seamless insight flow",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },
      {
        title: "Retail & E-commerce",
        description:
          "Retail intelligence is shifting from reactive insights to proactive personalization. We enable omnichannel retailers to anticipate consumer behavior, optimize supply, and create frictionless experiences powered by AI.",
        image: lawEnforcementImg,
        departments: [
          "Marketing",
          "Inventory",
          "Operations",
          "CX",
        ],
        highlights: [
          "Textual AI for contextual product recommendations and dynamic content",
          "Visual AI for planogram compliance and on-shelf visibility",
          "Analytical AI to forecast demand, pricing, and churn probability",
          "Conversational AI for multilingual, human-like customer engagement",
          "Functional AI for automated order management and returns optimization",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },
      {
        title: "Banking, Financial Services & Insurance (BFSI)",
        description:
          "In a world driven by data and trust, AI brings precision, compliance, and foresight. We enable BFSI enterprises to detect risks faster, automate decisions securely, and deliver hyper-personalized customer journeys.",
        image: sportsImg,
        departments: [
          "Risk",
          "Compliance",
          "Customer Operations",
          "Analytics",
        ],
        highlights: [
          "Analytical AI for fraud detection, credit scoring, and risk modeling",
          "Textual AI for regulatory document analysis and audit automation",
          "Conversational AI for intelligent customer service and advisory bots",
          "Functional AI for automated claim and loan processing",
          "Secure, compliant deployments adhering to ISO and GDPR standards",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },
      {
        title: "Healthcare",
        description:
          "From clinical diagnostics to patient engagement, AI is reshaping the healthcare ecosystem. We build compliant, explainable AI models that support clinicians, streamline operations, and elevate patient outcomes.",
        image: politicalImg,
        departments: [
          "Clinical",
          "Administration",
          "Patient Services",
          "Research",
        ],
        highlights: [
          "Visual AI for diagnostic imaging, pattern recognition, and triage support",
          "Analytical AI to predict patient flow and resource utilization",
          "Textual AI for automated medical record summarization",
          "Conversational AI for patient queries, triage, and post-care follow-up",
          "HIPAA-compliant frameworks ensure data privacy and reliability",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },
       {
        title: "Government & Public Sector",
        description:
          "AI is empowering public systems to become smarter, faster, and more transparent. We partner with government institutions to build scalable, secure AI ecosystems that strengthen service delivery and citizen engagement.",
        image: politicalImg,
        departments: [
          "Citizen Services ",
          "Policy Analytics",
          "Administration",
      
        ],
        highlights: [
          "Conversational AI for multilingual citizen support and feedback channels.",
          "Analytical AI to predict patient flow and resource utilization",
          "Functional AI for workflow automation in public offices.",
          "Textual AI for document digitization and policy summarization.",
          "Secure deployment architectures for sensitive data environments.",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },
       {
        title: "Education & Learning",
        description:
          "AI is transforming learning into a dynamic, data-driven experience. Our education solutions make content intelligent, assessment continuous, and learning outcomes measurable - at scale.",
        image: politicalImg,
        departments: [
          "L&D",
          "Academics",
          "Curriculum Design",
          "EdTech Platforms",
      
        ],
        highlights: [
          "Knowledge Nudge for personalized microlearning and skill reinforcement.",
          "Analytical AI for learner analytics and outcome tracking.",
          "Textual AI for intelligent content creation and summarization.",
          "Conversational AI for AI tutors and real-time feedback assistants.",
          "Adaptive systems that evolve with learner behavior and progress.",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },
             {
        title: "Sports ",
        description:
     "AI is redefining performance, strategy, and fan experience in sports. Our solutions deliver data-driven insights - from player analytics to audience engagement - empowering teams, leagues, and brands to make smarter moves on and off the field",
         image: governmentImg, 
     departments: [
          "Coaching ",
          " Performance ",
          "Media",
          "Fan Engagement",
      
        ],
        highlights: [
          "Visual AI for motion tracking, tactical analysis, and injury prevention.",
          "Analytical AI for player performance modeling and predictive scouting.",
          "Conversational AI for fan interactions and personalized engagement.",
          "Conversational AI for fan interactions and personalized engagement.",
          "AI-driven data visualization dashboards for live match intelligence.",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },

               {
        title: "Logistics & Supply Chain",
        description:
     "In logistics, milliseconds and insights define efficiency. Our AI platforms integrate predictive analytics, visual tracking, and automation to create intelligent, resilient supply chains that think ahead of disruption.",
        image: lawEnforcementImg,
     departments: [
          "Operations ",
          "Fleet",
          "Warehouse ",
          "Planning",
      
        ],
        highlights: [
          "Visual AI for automated shipment verification and warehouse safety.",
          "Analytical AI for route optimization and predictive logistics.",
          "Functional AI for inventory automation and order fulfillment.",
          "Textual AI for document processing and vendor communication.",
          "Unified AI orchestration across ERP and WMS systems.",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },

                    {
        title: "Energy & Utilities",
        description:
     "AI is driving sustainability and operational intelligence across energy grids, renewables, and utilities. Our AI solutions enable predictive maintenance, demand forecasting, and smarter energy management with reliability and safety at the core.",
         image: politicalImg,
         departments: [
          "Operations ",
          "Infrastructure",
          "Safety ",
          "Planning",
      
        ],
        highlights: [
          "Analytical AI for load forecasting and energy optimization.",
          "Visual AI for grid inspection and equipment monitoring.",
          "Functional AI for automated maintenance scheduling",
          "Conversational AI for customer service and outage management.",
          "End-to-end data pipelines ensuring scalability and compliance.",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },

                          {
        title: "Media & Communications",
        description:
     "AI is reinventing storytelling and engagement in the digital era. We empower media and communication companies to produce, personalize, and distribute content at speed and scale.",
         image: sportsImg,
         departments: [
          "Content ",
          " Marketing ",
          "Data Analytics",
          "Audience Engagement",
      
        ],
        highlights: [
          "Textual AI for automated scriptwriting, transcription, and summarization.",
          "Visual AI for content tagging, moderation, and highlight generation.",
          "Analytical AI for audience segmentation and performance analytics.",
          "Conversational AI for interactive user experiences and chat-driven content.",
          "Cloud-native, scalable architectures for high-volume content operations.",
        ],
        demoLink: "Request Demo",
        learnMoreLink: "Learn More",
      },
    ];
  
    const handleOpenPopup = () => {
  setIsPopupOpen(true);
};

    return (
      <section className="Main2 font-display mt-16 md:mt-0 bg-[#f8f9fa]">
        {/* Hero Section */}
        <section className="bg-custom-manage h-auto py-16 md:py-24 lg:py-32 flex justify-center items-center px-4">
          <article className="max-w-screen-2xl w-full text-center">
            <h1 className="text-2xl md:text-4xl lg:text-5xl 2xl:text-6xl font-bold text-[#666666] mb-6">
              Intelligence Across Industries
            </h1>
            <p className="text-sm md:text-base lg:text-lg 2xl:text-xl text-[#666666] max-w-4xl mx-auto">
              AI adoption looks different in every sector - but its power to transform remains constant. At Randomwalk, we build domain-intelligent systems that sense, learn, and act across industries. From visual intelligence to conversational systems, our AI platforms are engineered to solve complex challenges, enhance decision-making, and accelerate digital transformation at scale.
            </p>
          </article>
        </section>
  
        {/* Solutions Grid */}
        <section className="max-w-screen-2xl mx-auto px-4 md:px-8 lg:px-16 py-12 md:py-16 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
            {solutions.map((solution, index) => (
              <article
                key={index}
             className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 relative"
              >
                {/* Decorative bubble - alternating positions */}
                <figure
                  className={`absolute z-0 opacity-20 ${
                    index % 2 === 0
                      ? "-top-20 -left-20"
                      : "-bottom-20 -right-20"
                  }`}
                >
                  {/* <img
                    src={bubble1}
                    alt=""
                    className="w-64 h-64 md:w-80 md:h-80"
                  /> */}
                </figure>
  
                {/* Image Section */}
                <div className="relative h-48 md:h-64 overflow-hidden">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover"
                  />
               <div className="absolute inset-0 bg-gradient-to-t from-white to-transparent"></div>
                </div>
  
                {/* Content Section */}
                <div className="p-6 md:p-8 relative z-10">
                 <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#666666] mb-4">
                    {solution.title}
                  </h2>
                 <p className="text-sm md:text-base text-[#666666] mb-6">
                    {solution.description}
                  </p>
  
                  {/* Departments Covered */}
                  <div className="mb-6">
                  <h3 className="text-base md:text-lg font-semibold text-[#666666] mb-3">
                      Departments Covered
                    </h3>
                    <div className="flex flex-wrap gap-2">
                      {solution.departments.map((dept, deptIndex) => (
                        <span
                          key={deptIndex}
                          className="bg-[#3e59b7] bg-opacity-20 text-[#3e59b7] px-3 py-1 rounded-full text-xs md:text-sm font-medium border border-[#3e59b7] border-opacity-30"
                        >
                          {dept}
                        </span>
                      ))}
                    </div>
                  </div>
  
                  {/* Solution Highlights */}
                  <div className="mb-6">
               <h3 className="text-base md:text-lg font-semibold text-[#666666] mb-3">
  Solution Highlights
</h3>
                    <ul className="space-y-2">
                      {solution.highlights.map((highlight, highlightIndex) => (
                        <li
                          key={highlightIndex}
                       className="text-sm md:text-base text-[#666666] flex items-start"
                        >
                       <span className="text-[#3e59b7] mr-2 mt-1">▸</span>
                          <span>{highlight}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
  
                  {/* CTA Buttons */}
                  <div className="flex flex-col sm:flex-row gap-3 mt-6">
                  <button 
  onClick={handleOpenPopup}
  className="bg-[#3e59b7] hover:bg-[#1976D2] text-white px-6 py-3 rounded-lg text-sm md:text-base font-semibold transition-colors duration-300 flex items-center justify-center"
>
  {solution.learnMoreLink}
  <span className="ml-2">→</span>
</button>
                <button 
  onClick={handleOpenPopup}
  className="border-2 border-[#3e59b7] text-[#3e59b7] hover:bg-[#3e59b7] hover:bg-opacity-10 px-6 py-3 rounded-lg text-sm md:text-base font-semibold transition-colors duration-300"
>
  {solution.demoLink}
</button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
    <section
          className="text-[#666666] min-h-[180px] md:min-h-[230px] relative mt-20 bg-no-repeat bg-cover"
          style={{
            background: "linear-gradient(100deg , #3E59B7 90%, #A6BAFF 110%)", // Example pink gradient
          }}
        >
          <figure className="absolute bottom-0 right-0">
            <img
              src={recright}
              alt="Additional"
              loading="lazy"
              className="lg:w-40 lg:h-auto w-24 h-36 md:w-40 md:h-full"
            />
          </figure>
          <article className="absolute  inset-0 flex flex-col justify-center items-center text-center text-white pt-4 md:pt-10 md:mr-32 lg:pt-5 md:ml-20 ">
            <h2 className="md:text-xl lg:text-2xl text-sm font-bold mb-4 font-display">
           Ready to Experience Our AI Platforms?
            </h2>
            <p className="md:text-lg lg:text-lg text-sm font-light mb-4 font-display mx-2 ">
          Discover how our comprehensive AI platform suite can transform your <br/>enterprise operations and drive unprecedented growth.
            </p>

       <div className="flex gap-4 ">
  <button
    className="md:mt-3 mb-3 rounded-xl border text-[#3E59B7] bg-white md:py-3 md:px-20 px-8 py-2 transition-all duration-300 ease-in-out hover:bg-transparent hover:border hover:border-white hover:text-[#FFFFFF]"
    onClick={handleOpenPopup}

  >
    <div className="flex items-center">
      <span className="text-xs md:text-lg font-bold">Start Free Trial</span>
    </div>
  </button>

  <button
    className="md:mt-3 mb-3 rounded-xl border text-white border-white md:py-3 md:px-20 px-8 py-2 transition-all duration-300 ease-in-out bg-transparent hover:bg-white hover:text-[#3E59B7]"
   onClick={handleOpenPopup}

  >
    <div className="flex items-center">
      <span className="text-xs md:text-lg font-bold">Schedule Demo
      </span>
    </div>
  </button> 
</div>
          </article>
        </section>
        {/* Don't See Your Industry Section */}
       
  
        {/* Popup Section */}
       {/* Popup Section */}
{isPopupOpen && (
  <Popup 
    utmContent={"industry-solutions"}
    isModalOpen={isPopupOpen}
    setIsModalOpen={setIsPopupOpen}
  />
)}
      </section>
    );
  };
  
  export default IndustrySolutions;
  